import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=d2891f8a&scoped=true&"
import script from "./MeetingDetails.vue?vue&type=script&lang=js&"
export * from "./MeetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./MeetingDetails.vue?vue&type=style&index=0&id=d2891f8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2891f8a",
  null
  
)

export default component.exports